import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const retrieve = ({ commit }, id) => {
  commit(types.INTERNALANNOUNCEMENT_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.INTERNALANNOUNCEMENT_SHOW_TOGGLE_LOADING)
      commit(types.INTERNALANNOUNCEMENT_SHOW_SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.INTERNALANNOUNCEMENT_SHOW_TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.INTERNALANNOUNCEMENT_SHOW_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.INTERNALANNOUNCEMENT_SHOW_RESET)
}
